import styled from "styled-components";

const BodyWrapper = styled.div`
  /* max-height: 44vh;
  min-height: 44vh; */
  overflow-y: scroll;
  /* position: fixed;
  bottom: 30px; */
  padding-bottom: 20px;
  width: 100%;

  .table {
    border-collapse: separate;
    border-spacing: 0 1em;
    width: 95%;

    .tableHeader th:not(:first-child) {
      position: absolute;
      text-align: left;
      font-size: 12px;
      color: #004576;
      padding-left: 15px;
      cursor: pointer;
      position: sticky;
      top: 0;
      background-color: white;
    }

    .tableHeader th:nth-child(1) {
      position: absolute;
      text-align: left;
      font-size: 12px;
      color: #004576;
      /* padding-left: 15px; */
      cursor: pointer;
      position: sticky;
      top: 0;
      background-color: white;
    }

    .tableRow {
      font-size: 16px;
      padding-top: 17px;

      .email {
        color: #008df1;
        cursor: pointer;
        text-decoration: underline;
      }

      .button {
        color: #008ef2;
        cursor: pointer;
        text-decoration: underline;
        font-weight: 600;
      }
    }

    .tableRow td:not(:last-child, :first-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.15);
      padding-left: 15px;
    }

    .tableRow td:nth-child(1) {
      border-right: 1px solid rgba(0, 0, 0, 0.15);
      /* padding-left: 15px; */
    }

    .tableRow td:not(:first-child) {
      padding-left: 15px;
    }
  }
`;

const CurrentUserInfoTable = ({ loggedUser, onEditClick }) => {
  const handleMailClick = (mailId) => {
    window.open(`mailto:${mailId}`);
  };

  const formatPhoneNumber = (str) => {
    let cleaned = ("" + str).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  };

  return (
    <BodyWrapper>
      <table className="table">
        <tr className="tableHeader">
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <th>Phone Number</th>
          <th>Role</th>
          <th>Advisor Code</th>
          <th>&nbsp;</th>
        </tr>
        <tr className="tableRow">
          <td>{loggedUser?.firstName || ""}</td>
          <td>{loggedUser?.lastName || ""}</td>
          <td
            className="email"
            onClick={() => handleMailClick(loggedUser?.email)}
          >
            {loggedUser?.email || ""}
          </td>
          <td>{formatPhoneNumber(loggedUser?.phoneNumber) || ""}</td>
          <td>{loggedUser?.role || ""}</td>
          <td>{loggedUser?.advisorCode || ""}</td>
          <td
            className="button"
            onClick={() => onEditClick(loggedUser?.userId, "myDetails")}
          >
            Edit
          </td>
        </tr>
      </table>
    </BodyWrapper>
  );
};

export default CurrentUserInfoTable;
